import api from "./api";

// LMS in-app notifications (students & teachers). Backend: /api/notifications.

export const getNotifications = async (params = {}) => {
  // params: { status: "all"|"unread"|"read", page, pageSize, kind }
  const response = await api.get("/notifications", { params });
  return response.data;
};

export const getUnreadCount = async () => {
  const response = await api.get("/notifications/count");
  return response.data;
};

export const markNotificationRead = async (id) => {
  const response = await api.post(`/notifications/${id}/read`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
  const response = await api.post("/notifications/read-all");
  return response.data;
};
